import PropTypes from 'prop-types'
import React from 'react'
import { useQuery } from '@apollo/client'
import get from 'lodash/get'
import { GET_COMPARE } from 'Queries'
import { ErrorView, ArticleProductCard, Grid } from 'Blocks'
import Loading from './Loading'
import {
  PAGE_CONTEXT as p,
  COMPARE_MODAL_PRODUCTS,
  COMPARE_QUERY_PAGE
} from 'Constants'

const ProductModalContent = props => {
  const variables = {
    arguments: {
      productUuid: props.productUuid,
      ccUuid: props.ccUuid || ''
    },
    pagination: {
      size: COMPARE_MODAL_PRODUCTS,
      page: COMPARE_QUERY_PAGE
    }
  }

  const isEmbedModal = props.variant === 'embedModal'
  const pageName = isEmbedModal ? p.EMBED_MODAL : p.ARTICLE_MODAL

  const { loading, error, data } = useQuery(GET_COMPARE, { variables })

  if (loading) return <Loading />
  if (error) return <ErrorView message={error.message} error={error} />
  if (get(data, 'compare.products', false)) {
    return (
      <Grid
        className={props.itemsPerRow === 1 ? 'single-product' : ''}
        pageName={pageName}
      >
        {data.compare.products.map(product => {
          return (
            <ArticleProductCard
              cardContext="OOS Modal"
              variant={props.variant}
              isEmbedModal={isEmbedModal}
              isModal
              key={product.uuid}
              product={product}
            />
          )
        })}
      </Grid>
    )
  }

  return null
}

ProductModalContent.propTypes = {
  ccUuid: PropTypes.string,
  itemsPerRow: PropTypes.number,
  productUuid: PropTypes.any,
  variant: PropTypes.string
}

export default ProductModalContent
